// extracted by mini-css-extract-plugin
export default {"nav_box":"index_nav_box_PdsGm","main_nav":"index_main_nav_FkmWj","userinfo":"index_userinfo_aJeor"};